import axios from 'axios';


//create a axios instance with base configuration 
const api = axios.create(
    {
        baseURL: process.env.REACT_APP_API_URL,
         headers: { 'Content-Type': 'application/json' }
    }
)


api.interceptors.request.use(
    (config) =>{
        const token = localStorage.getItem('token');
        if(token){
            config.headers.Authorization = `Bearer ${token}`
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
)


//Response interceptor - hanlde error globally

api.interceptors.response.use(
    (response) =>  response,
    (error) => {
        if(error.response?.status === 401){
            localStorage.removeItem('token')
            window.location.href ='/login'
        }
    return Promise.reject(error);
    }
)


export default api;